// assets/section-value-propositions.js

(function() {
  function initValPropsSlider(sectionContainer) {
    const swiperEl = sectionContainer.querySelector('.val-props-container--mobile.swiper');
    if (!swiperEl) return;

    let swiperInstance = null;

    function handleResize() {
      const isMobile = window.innerWidth < 750;
      if (isMobile && !swiperInstance) {
        swiperInstance = new Swiper(swiperEl, {
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          slidesPerView: 1,
          spaceBetween: 16,
        });
        sectionContainer.swiperInstance = swiperInstance;
      } else if (!isMobile && swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
        sectionContainer.swiperInstance = null;
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
  }

  // Auto initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.val-props-bar').forEach(initValPropsSlider);
  });

  // Handle Shopify Section Load event in customizer
  document.addEventListener('shopify:section:load', function(event) {
    const sectionContainer = event.target.querySelector('.val-props-bar');
    if (sectionContainer) {
      initValPropsSlider(sectionContainer);
    }
  });

  // Handle section unload to cleanup
  document.addEventListener('shopify:section:unload', function(event) {
    const sectionContainer = event.target.querySelector('.val-props-bar');
    if (sectionContainer && sectionContainer.swiperInstance) {
      sectionContainer.swiperInstance.destroy(true, true);
    }
  });
})();
